/**
 * Tokenul de invitație stă în fragmentul URL-ului (`#token=...`), nu în query:
 * fragmentul nu e trimis serverului, deci nu ajunge în access log-ul
 * proxy-ului și nici în antetul Referer. Query-ul e citit doar ca rezervă,
 * pentru linkurile emise înainte de această schimbare.
 */
export function readInviteToken(name: 'token' | 'invite'): string | null {
  const fromHash = new URLSearchParams(window.location.hash.replace(/^#/, '')).get(name);
  if (fromHash) return fromHash;
  return new URLSearchParams(window.location.search).get(name);
}
